import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import reactGA4 from 'react-ga4';
import { ANALYTICS_ENABLED } from '../utils/analytics';

export const usePageTracking = (): void => {
  const location = useLocation();

  useEffect(() => {
    if (!ANALYTICS_ENABLED) return;
    if (location.pathname === '/') return;
    reactGA4.send({
      hitType: 'pageview',
      page: location.pathname + location.search,
    });
  }, [location]);
};
